import React from 'react';

import PropTypes from 'prop-types';

import {
  DownArrowIcon,
  UpArrowIcon,
  WhiteRightArrow
} from 'src/Components/Common';

import {
  cardKey
} from 'src/Common/constants';

import {
  getDrivePackageImageURL
} from 'src/Utility/utility';

import VodacomLogo from 'src/Common/Images/vodacom-white-logo.png';

import './Card.css';

function Card(props) {

  const getPromotion = (key) => {

    return cardKey[key];
  };

  const formatNumber = (number, decimalPlaces = 2) => {
  
    number = parseFloat(number);

    if (Number.isInteger(number)) {

      return number.toString();

    } else {

      if (Math.abs(number - Math.round(number)) < Number.EPSILON) {
        return Math.round(number).toString();
      } else {
        return number.toFixed(decimalPlaces);
      }
    }
  }

  const renderPrepaidCard = () => {

    return (
      <div
        className='prepaid-card-main-container'
        onClick={props.selectPackage}>

        <div className='card-discount-logo-container'>
          <div className="card-provider-logo">
            <img
              className='provider-logo'
              src={VodacomLogo}
              alt="provider" />
          </div>

          {/* TO-DO: Need to confirm the this */}

          <div className='prepaid-fibre'>
            Prepaid Fibre
          </div>
        </div>

        <div className="card-inclusion-section">

          <div className="card-price-wrapper">

            <div className="card-price">
              <div className='prepaid-card-price-from-only'>
                Get prepaid fibre from only
              </div>

              <div className='prepaid-card-price-text'>{`R${ parseFloat(props.price).toFixed() }`}
                <div>PM</div>
              </div>
            </div>

          </div>

          <div className="prepaid-fibre-button-container">
            <div className="prepaid-fibre-button">
              <div className="prepaid-fibre-text">
                See available offers
              </div>

              <WhiteRightArrow />
            </div>
          </div>
        </div>
      </div>

    );
  };

  return (

    <>
      { props.subscriptionType === 'Prepaid'

        ? <>{renderPrepaidCard()}</>

        :
        <div
          className={`card-main-container ${ props.isTopPick ? 'top-pick' : '' }`}
          onClick={props.selectPackage}
        >

          <div className='card-discount-logo-container'>
            <div className="card-provider-logo">
              <img
                className='provider-logo'
                src={getDrivePackageImageURL(props.providerLogo)}
                alt="provider" />
            </div>

            {/* TO-DO: Need to confirm the this */}
            { Object.keys(cardKey).includes(props.cardKey)
              ?(
                <div className={`${ props.isTopPick ? 'card-promotion-top-pick' : 'card-promotion' } ${ props.cardKey?.toLowerCase() }`}>
                  {getPromotion(props.cardKey)}
                </div>
              ):
              (
                <div className={`card-promotion ${ props.promotion ? '' : 'unavailable' }`}>
                  {props.promotion && 'On promotion'}
                </div>
              )
            }
          </div>

          <div className="card-inclusion-section">

            <div className="card-price-wrapper">

              <div className="card-price">
                <div className='card-price-from-only'>
            From only
                </div>
                <div className={`${ props.isTopPick ? 'card-price-text-top-pick' : 'card-price-text' } ${ props.cardKey === 'mostPopular'  ? 'special-text' : '' }`} >
                  {`R${ formatNumber(props.price) }`}
                  <div className='duration-tag'>PM</div>
                  {props.promotion && props.originalPrice && <div className='card-original-price'>{`R${ parseFloat(props.originalPrice).toFixed() } PM`}</div>}
                </div>
              </div>

              <div className={`${ props.isTopPick ? 'card-price-duration-top-pick' : 'card-price-duration' } ${ props.cardKey === 'mostPopular'  ? 'special-text' : '' }`} >
                {props.duration  === 'Month to Month' ? 'month-to-month' : `x ${ props.duration.toLowerCase() }` }
              </div>
            </div>

            <div className="card-speed-wrapper">

              <div className={`${ props.isTopPick ? 'speed-wrapper-top-pick': 'speed-wrapper' } `}>
                <div className="and-symbol-wrapper">
                  <DownArrowIcon />
                </div>

                <div className="speed-value">
                  {props.downloadSpeed}
                </div>
              </div>

              <div className={`${ props.isTopPick ? 'speed-wrapper-top-pick': 'speed-wrapper' } `}>
                <div className="and-symbol-wrapper">
                  <UpArrowIcon />
                </div>

                <div className="speed-value">
                  {props.uploadSpeed}
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </>

  );
}

Card.propTypes = {
  selectPackage: PropTypes.func.isRequired,
  providerLogo: PropTypes.string,
  promotion: PropTypes.bool,
  price: PropTypes.string.isRequired,
  originalPrice: PropTypes.string,
  duration: PropTypes.string.isRequired,
  downloadSpeed: PropTypes.string.isRequired,
  uploadSpeed: PropTypes.string.isRequired,
  cardKey: PropTypes.string,
  subscriptionType: PropTypes.string,
  isTopPick: PropTypes.bool
};

export default Card;
